import FusePageSimple from "@fuse/core/FusePageSimple";
import { styled } from "@mui/material/styles";

import CrmHeaderStatic from 'app/main/crm/header/CrmHeaderStatic';
import CrmFooter from 'app/main/crm/footer/CrmFooter';
import ForgotPasswordContent from 'app/main/crm/forgot-password/content/ForgotPasswordContent';


const Root = styled(FusePageSimple)(() => ({
    "& .FusePageCarded-topBg": {
        background: "unset"
    },
    minHeight: "unset",
    "& .FusePageSimple-contentCard, .FusePageSimple-header": {
        backgroundColor: "unset",
        background: "unset",
        boxShadow: "unset"
    },
    "& .ps__rail-y": {
        display: "none !important"
    }
}));

function ForgotPassword(props) {

    return (
        <div className="flex flex-col flex-auto min-h-screen min-w-0 relative z-10">
            <CrmHeaderStatic title={"Reset Password"} />
            <Root
                content={
                    <div className="max-w-1366px m-auto">
                        <ForgotPasswordContent />
                    </div>
                }
            />
            <CrmFooter />
        </div>
    );
}

export default ForgotPassword;

